import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';
import { SvgIcon, HTMLParser, Zoom } from '@gik/ui';
import { PreviewSection } from '../PreviewSection';
import CompetitorsComparisonTable from '../CompetitorsComparisonTable';

const blockName = 'competitors-preview';

export default function CompetitorsPreview(): React.ReactElement {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  return (
    <PreviewSection
      className={bem()}
      boxLink="/competitors"
      boxContent={
        <>
          <span className={bem('title')}>{HTMLParser({ rawHtml: t(translationKeys.title) })}</span>
          <div className={bem('content')}>
            <main>
              <div className={bem('description')}>{HTMLParser({ rawHtml: t(translationKeys.description) })}</div>
            </main>
            <aside>
              <SvgIcon name="ArrowCircleRightOutline" className={bem('icon')} size="xl" />
            </aside>
          </div>
        </>
      }
    >
      <Zoom level={0.7}>
        <CompetitorsComparisonTable hasStickyHeader={false} className={bem('table')} />
      </Zoom>
    </PreviewSection>
  );
}
